document.addEventListener('click', function (e) {
  var boton = e.target.closest('[data-persa-comprar]');
  if (!boton) return;
  e.preventDefault();
  var form = boton.closest('form');
  if (!form) return;
  var id = form.querySelector('[name="id"]');
  var cantidad = form.querySelector('[name="quantity"]');
  if (!id || !id.value) return;
  boton.disabled = true;
  boton.setAttribute('aria-busy', 'true');
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id.value), quantity: cantidad ? Number(cantidad.value) || 1 : 1 }] })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = '/checkout';
    })
    .catch(function () {
      boton.disabled = false;
      boton.removeAttribute('aria-busy');
      alert('No pudimos agregar el cuadro. Probá de nuevo en unos segundos.');
    });
});
